import { ref, computed } from 'vue'
import { format } from 'date-fns'
import { fr, enUS } from 'date-fns/locale'

export function useFormatDate() {
    const locale = computed(() => i18n.global.locale.value)

    function formatSampleMyDateWithoutHour(date){
        return format(new Date(date), 'dd-MM-yyyy', {
            locale: locale.value === 'fr' ? fr : enUS
        })
    }

    return { formatSampleMyDateWithoutHour }
}